import { actionType } from '../actions/seller';
import baseInitState from '../baseInitState';
import baseReducer from '../baseReducer';

const initState = {
  ...baseInitState,
};

export default function seller(state = initState, action) {
  switch (action.type) {
    default:
      return baseReducer(state, action, actionType);
  }
}
